import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SelectedVat = styled.div`
  padding: ${Spacing.S8} ${Spacing.S12};
  border-radius: ${BorderRadius.R6};
  background-color: ${Color.Grey50};
  cursor: not-allowed;
`
